<div class="boolean-check-container" [matTooltip]="tooltipKey ? (tooltipKey | translate) : ''"
  [matTooltipDisabled]="!tooltipKey" (click)="onClick($event)" [class.clickable]="action">
  <mat-icon [style.color]="getColor()" class="checkbox-icon">{{ getIcon() }}</mat-icon>
</div>